<template>
    <div class="prolb">
        <Headpro></Headpro>
        <Selected :selected="selected"></Selected>
        <Xmlist :list="list"></Xmlist>
        <Bottom_comp></Bottom_comp>
        <Footer></Footer>
    </div>
</template>

<script>
    import Headpro from '@/components/project/Headpro.vue'
    import Selected from '@/components/project/Selected.vue'
    import Xmlist from '@/components/project/Xmlist.vue'
    import Footer from '@/components/Footer.vue'
    import Bottom_comp from "../components/Bottom_comp";
    import {getReq} from "../utils/api";
    export default {
        name: "ProList",
        data(){
            return {
                selected:'',
                list:'',

            }
        },
        mounted(){
            this.getlist();
        },
        methods:{
            getlist(){
                getReq('/getProList').then((res)=>{
                    if(res.code=="200"){
                        this.selected = res.data.selected;
                        this.list = res.data.list;
                    }
                })
            }
        },
        components:{
            Bottom_comp,
            Headpro,
            Selected,
            Xmlist,
            Footer

        }
    }
</script>

<style scoped lang="scss">


</style>
